import { BaseFieldConfig, ComponentNameEnum } from '@/types';

const bordersFieldConfig: BaseFieldConfig = {
  componentName: ComponentNameEnum.BORDERS,
  options: {
    defaultBorderStyle: 'solid',
    defaultColor: '#000000',
    defaultWidth: 1,
  },
};
export default bordersFieldConfig;
